import { AppBar, Box, Divider, Toolbar, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import Profile from "./Profile";
// import SearchField from "../Input/SearchField";
import Logo from "../../Assets/Logo6D.png";
// import Logo from "../../Assets/favicon.png";
import { getShowModal } from "../../Redux/DetailsofProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { BaseUrl, cookies, Domainurl, ImageUrl } from "../../Controller/Common";
import { RootState } from "../../Redux/UserSlice";
import axios from "axios";
import { GetTheme } from "../../Redux/ThemeSlice";
import AsscessDeniedModal from "../Modal/AsscessDeniedModal";
import CustomModal from "../Modal/CustomModal";

interface StateType {
  profileDetails: {
    editSatus: any;
    showModal: any;
  };
}
interface StateType {
  classRoom: {
    classroomPage: any;
    enrolledCourse: any;
    coursestatus: any;
  };
}

export default function MyAppBar() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = location.pathname;
  const userId = cookies.get("userId");
  const [show, setShow] = useState(false);
  const StoresuserId = useSelector((state: RootState) => state.user.userID);
  const [shouldShowSearchAndProfile, setShouldShowSearchAndProfile] =
    useState(false);
  const { coursestatus } = useSelector((state: StateType) => state.classRoom);
  const setEdit = useSelector(
    (state: StateType) => state.profileDetails.editSatus
  );
  const nextPage = useSelector(
    (state: StateType) => state.classRoom.classroomPage
  );

  const [data, setData] = useState({
    domain: "",
    header_image: "",
    id: null,
    app: "",
  });
  const [domain, setDomain] = useState("");

  useEffect(() => {
    if (
      path !== "/" &&
      path !== "/signin" &&
      path !== "/signup" &&
      path !== "/verification" &&
      (StoresuserId || userId)
    ) {
      setShouldShowSearchAndProfile(true);
    } else {
      setShouldShowSearchAndProfile(false);
    }
  }, [path, StoresuserId, userId]);

  const extractSubdomain = (): string | null => {
    try {
      const url = window.location.hostname; 
      const parts = url.split(".");
      if (parts.length > 0) {
        return parts[0]; 
      }
      return null;
    } catch (error) {
      console.error("Error extracting subdomain:", error);
      return null;
    }
  };

  const GetSubdomain = async (subdomain: string) => {
    try {
      setDomain(subdomain);
      const url = Domainurl(subdomain); 
      console.log("Fetching from:", url); 
      const response = await axios.get(url);

      if (response.status === 200) {
        setData(response.data);
        dispatch(GetTheme(response.data.theme));
      }
    } catch (error) {
      console.error("Error fetching subdomain data:", error);
    }
  };

  const subdomain = extractSubdomain();

  useEffect(() => {
    console.log("useEffect triggered with subdomain:", subdomain);
    if (subdomain) {
      GetSubdomain(subdomain);
    }
  }, [subdomain]);

  return (
    <>
      <AppBar>
        <Toolbar sx={{ height: "72px" }}>
          <NavBox>
            {/* <Typography className="Nav6D">6D</Typography> */}
            <img
              // src={Logo}
              src={
                domain
                  ? `${ImageUrl}/header/${data.header_image}`
                  : domain.startsWith("6d")
                  ? Logo
                  : Logo
              }
              alt="6D Logo"
              width="48px"
              height="40px"
              onClick={() => {
                if (
                  path === "/landing/classroom" &&
                  nextPage !== 1 &&
                  nextPage !== 0 &&
                  coursestatus !== "COMPLETED"
                ) {
                  setShow(true);
                } else if (path === "/landing/profile" && setEdit === true) {
                  dispatch(getShowModal(true));
                } else if (shouldShowSearchAndProfile) {
                  navigate("/landing/activity");
                } else {
                  navigate("/");
                }
              }}
              style={{ cursor: "pointer" }}
            />
            <Divider className="Vertical" />
            <Typography className="NavTP">
              {data.app ? data.app : "Learning"}
            </Typography>
            {/* <Typography className="NavTP">
            {domain
              ? data.domain
              : domain.startsWith("6d")
              ? "Learning"
              : "Learning"}
          </Typography> */}
          </NavBox>
          {shouldShowSearchAndProfile && (
            <>
              {/* <SearchField /> */}
              <Profile />
            </>
          )}
        </Toolbar>
      </AppBar>
      <CustomModal
        open={show}
        handleClose={() => setShow(false)}
        child={<AsscessDeniedModal setOpen={setShow} open={show} />}
      />
    </>
  );
}
const NavBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 100px; */
  /* margin: 0 0 0 px; */
`;
